import styled, { css } from 'styled-components';
import { rem } from 'polished';
import mediaqueries from '../../../config/themes/variables/mediaqueries';
import Icon from '../Icon';
import Buttons from '../Buttons';
import Modal from '../Modal';
import Input from '../Input';

const StyledInput = styled(Input)`
  ${mediaqueries.greaterThan('tabletLandscape')`
    & > input::placeholder {
      opacity: 0;
    }
  `};
`;

const StyledSearchFilterButton = styled.button`
  font-family: ${props => props.theme.fonts.bold};
  align-items: center;
  background-color: ${props => props.theme.colors.primary};
  border: ${rem('0px')};
  bottom: 0;
  color: ${props => props.theme.colors.light};
  cursor: pointer;
  display: ${props => (props.modalActive ? css`none` : css`block`)};
  font-size: ${rem('14px')};
  height: ${rem('60px')};
  justify-content: center;
  left: 0;
  opacity: 0.95;
  position: fixed;
  text-transform: uppercase;
  width: 100%;
  z-index: 10;
  ${mediaqueries.greaterThan('tabletLandscape')`
    display: none;
  `};
`;

const StyledModal = styled(Modal)`
  text-align: left;
  h2 {
    padding-left: ${rem('12px')};
  }

  ${mediaqueries.greaterThan('tabletLandscape')`
    display: none;
  `};
`;

const StyledIconClose = styled(Icon)`
  display: inline-block;
  vertical-align: middle;
  width: ${rem('12px')};
  ${mediaqueries.greaterThan('tabletLandscape')`
    display: none;
  `};
`;

const StyledSearchFilterWrapper = styled.div`
  text-align: left;
  display: ${props => (props.modalActive ? css`block` : css`none`)};
  ${mediaqueries.greaterThan('tabletLandscape')`
    display: flex;
    align-items: center;
    flex-direction: row;
    padding: ${rem('0px')};
    background-color: #f3f3f3;
    box-shadow: inherit;
    position: relative;    
  `};
`;

const StyledSearchFilterRow = styled.fieldset`
  width: 100%;
  margin: 0 ${rem('12px')} 0 0;
  ${mediaqueries.greaterThan('tabletLandscape')`
    margin-left: ${rem('15px')}
  `};
`;
const StyledRemoveFilters = styled(StyledSearchFilterRow)`
  display: none;
  text-align: right;
  ${mediaqueries.greaterThan('tabletLandscape')`
    position: absolute;
    top: ${rem('-33px')};
    right: ${rem('-24px')};
    display: block;
  `};
`;

const StyledButtonsModal = styled(StyledSearchFilterRow)`
  margin-top: ${rem('20px')};
  padding: ${rem('0px')};
  text-align: center;
  margin-top: ${rem('20px')};
  padding: ${rem('0px')};
  text-align: center;
  width: ${rem('281px')};
  float: right;
  ${mediaqueries.greaterThan('tabletLandscape')`
    display: none;
  `};
`;

const StyledBtnFilters = styled.button`
  display: none;
  color: ${props => props.theme.colors.dark};
  font-family: ${props => props.theme.fonts.mediumItalic};
  font-size: ${rem('14px')};
  background: none;
  border: none;
  margin-left: ${rem('7px')};
  text-decoration: underline;
  ${mediaqueries.greaterThan('tabletLandscape')`
    font-size: ${rem('12px')};
    display: inline;
  `};
`;

const StyledSearchFilterLabel = styled.label`
  color: ${props => props.theme.colors.dark};
  font-family: ${props => props.theme.fonts.medium};
  font-size: ${rem('12px')};
`;

const StyledSFRowName = styled(StyledSearchFilterRow)`
  ${mediaqueries.greaterThan('tabletLandscape')`
    display: block;
    margin-top: ${rem('0px')};
    padding-left: 0;
    padding-right: 0;
  `};
`;

const StyledSFRowTitle = styled(StyledSearchFilterRow)`
  display: none;
  ${mediaqueries.greaterThan('tabletLandscape')`
    background-color: ${props => props.theme.colors.grayLighter};
    color: ${props => props.theme.colors.dark};
    display: block;
    font-family: ${props => props.theme.fonts.medium};
    font-size: ${rem('14px')};
    line-height: 4;
    overflow: hidden;
    text-align: center;
    text-overflow: ellipsis;
    text-transform: uppercase;
    white-space: nowrap;
    width: ${rem('218px')};
    transition: 0.5s; 
    margin: 0;
    padding:  ${rem('27px')} 0;
  `};
`;

const StyledSFRowSurname = styled(StyledSearchFilterRow)`
  ${mediaqueries.greaterThan('tabletLandscape')`
    display: block;
    padding-left: 0;
    padding-right: 0;
  `};
`;

const StyledSFRowDepartment = styled(StyledSearchFilterRow)`
  position: relative;
  ${mediaqueries.greaterThan('tabletLandscape')`
    display: block;    
    padding-left: 0;
    padding-right: 0;
  `};
`;

const StyledButton = styled(Buttons)`
  margin: 0 ${rem('10px')};
  font-size: ${rem('14px')};
  padding-top: ${rem('8px')};
  padding-bottom: ${rem('8px')};
`;

const StyledRowInputs = styled.div`
  ${mediaqueries.greaterThan('tabletLandscape')`
    display: flex;
    justify-content: space-around;
    width: 100%;
    padding: ${rem('15px')};
  `};
`;

const StyledButtonDesktop = styled(StyledButton)`
  display: none;
  ${mediaqueries.greaterThan('tabletLandscape')`
    display: block;
    margin-top: ${rem('20px')};
    margin-right: ${rem('30px')};
    height: ${rem('38px')};
    ${props =>
      props.disabled &&
      css`
        opacity: 0.6;
        background-color: ${props.theme.colors.secondary};
        color: ${props.theme.colors.light};
        &:hover {
          background-color: ${props.theme.colors.secondary};
          color: ${props.theme.colors.light};
        }
      `}
  `};
`;

const StyledAutocomplete = styled.div`
  max-width: calc(100% - ${rem('24px')});
  left: ${rem('12px')};
  position: absolute;
  top: ${rem('70px')};
  background-color: ${props => props.theme.colors.light};
  border: ${rem('1px')} ${props => props.theme.colors.grayLight} solid;
  width: 100%;
  ${mediaqueries.greaterThan('tabletLandscape')`
    left: 0;
    max-width: ${rem('175px')};
  `};
`;

const StyledAutocompleteList = styled.ul`
  margin: 0;
  padding: 0;
`;

const StyledAutocompleteItem = styled.li`
  padding: 0;
  margin: 0;

  &:before {
    display: none;
  }
`;

const StyledAutocompleteButton = styled.button`
  background-color: transparent;
  border: none;
  font-size: 14px;
  padding: ${rem('12px')};
  width: 100%;
  &:hover {
    background-color: ${props => props.theme.colors.grayLight};
  }
`;

const StyledSFRowEmployeeId = styled(StyledSearchFilterRow)`
  ${mediaqueries.greaterThan('tabletLandscape')`
    display: block;
    padding-left: 0;
    padding-right: 0;
  `};
`;

export {
  StyledModal,
  StyledButton,
  StyledButtonsModal,
  StyledIconClose,
  StyledBtnFilters,
  StyledRemoveFilters,
  StyledSFRowDepartment,
  StyledSFRowName,
  StyledSFRowSurname,
  StyledSFRowTitle,
  StyledSearchFilterButton,
  StyledSearchFilterLabel,
  StyledSearchFilterWrapper,
  StyledRowInputs,
  StyledInput,
  StyledButtonDesktop,
  StyledAutocomplete,
  StyledAutocompleteList,
  StyledAutocompleteItem,
  StyledAutocompleteButton,
  StyledSFRowEmployeeId
};
